const COMMON_SECOND_LEVEL_TLDS = new Set(['co', 'com', 'net', 'org', 'gov', 'edu']);

const isIpAddress = (value) => /^\d{1,3}(?:\.\d{1,3}){3}$/.test(value);

const formatPlatformLabel = (value) => value
  .split(/[-_]/g)
  .filter(Boolean)
  .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
  .join(' ');

const extractPlatformKeyFromHostname = (hostname) => {
  const normalizedHostname = `${hostname || ''}`
    .trim()
    .toLowerCase()
    .replace(/:\d+$/, '');

  if (!normalizedHostname || normalizedHostname === 'localhost' || isIpAddress(normalizedHostname)) {
    return null;
  }

  const parts = normalizedHostname.split('.').filter(Boolean);
  if (parts.length === 0) {
    return null;
  }

  if (parts.length === 1) {
    return parts[0];
  }

  const lastPart = parts[parts.length - 1];
  const secondLastPart = parts[parts.length - 2];

  if (
    parts.length >= 3
    && lastPart.length === 2
    && COMMON_SECOND_LEVEL_TLDS.has(secondLastPart)
  ) {
    return parts[parts.length - 3];
  }

  return secondLastPart;
};

const getHostnameFromValue = (value) => {
  const rawValue = `${value || ''}`.trim();
  if (!rawValue) {
    return '';
  }

  const normalizedValue = /^https?:\/\//i.test(rawValue) ? rawValue : `https://${rawValue}`;

  try {
    return new URL(normalizedValue).hostname;
  } catch (error) {
    return '';
  }
};

export const getPlatformNameFromUrl = (value, fallback = '') => {
  const hostname = getHostnameFromValue(value);
  const platformKey = extractPlatformKeyFromHostname(hostname);
  return platformKey ? formatPlatformLabel(platformKey) : fallback;
};

export const getCurrentPlatformName = (fallback = '') => {
  if (typeof window === 'undefined') {
    return fallback;
  }

  const platformKey = extractPlatformKeyFromHostname(window.location.hostname);
  return platformKey ? formatPlatformLabel(platformKey) : fallback;
};
